import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AdminAuthService } from '../../shared/services/admin-auth/admin-auth.service';

export const adminGuard: CanActivateFn = (route, state) => {
  const adminAuthService = inject(AdminAuthService);
  const router = inject(Router);

  // Check admin authentication status
  const isAuthenticated = adminAuthService.isAuthenticated();

  if (isAuthenticated) {
    // Admin is authenticated, allow access
    return true;
  }

  // Admin is not authenticated
  // Define public admin routes that don't require authentication
  const publicAdminRoutes = ['/admin/login'];
  const isPublicRoute = publicAdminRoutes.some(
    (publicRoute) => state.url === publicRoute || state.url.startsWith(publicRoute),
  );

  // If trying to access a protected admin route, redirect to admin login
  if (!isPublicRoute) {
    router.navigate(['/admin/login'], {
      queryParams: { returnUrl: state.url },
      replaceUrl: true,
    });
  }

  // Return false to prevent access to protected admin routes
  return false;
};
